const isValidPostalCode = (postalCode) =>
  !!postalCode?.toString().match(/^[0-9]{5}(?:-[0-9]{4})?$/);

export default isValidPostalCode;
